module.exports = __webpack_public_path__ + "img/logo.838a3ff3.png";